import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { getAllOrdersOfUser } from "../../redux/actions/order";
import { AiOutlineArrowRight } from "react-icons/ai";

const AllRefundOrders = () => {
  const { user } = useSelector((state) => state.user);
  const { orders } = useSelector((state) => state.order);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAllOrdersOfUser(user._id));
  }, [dispatch, user._id]);

  const eligibleOrders = orders?.filter((order) => order.status === "Processing refund") || [];
  const refundItems = eligibleOrders.reduce((total, order) => total + (order.cart?.length || 0), 0);
  const refundValue = eligibleOrders.reduce((total, order) => total + (Number(order.totalPrice) || 0), 0);

  return (
    <div className="profile-refunds-panel">
      <section className="profile-refunds-summary-grid" aria-label="Refund summary">
        <article className="profile-refunds-summary-card">
          <span>Open Refunds</span>
          <strong>{eligibleOrders.length}</strong>
        </article>
        <article className="profile-refunds-summary-card">
          <span>Items Under Review</span>
          <strong>{refundItems}</strong>
        </article>
        <article className="profile-refunds-summary-card">
          <span>Refund Value</span>
          <strong>US$ {refundValue.toFixed(2)}</strong>
        </article>
      </section>
      {eligibleOrders.length > 0 ? (
        <div className="profile-content-component-orders profile-refunds-table-shell">
          <table className="profile-content-component-table">
            <thead>
              <tr>
                <th>Order ID</th>
                <th>Status</th>
                <th>Items Qty</th>
                <th>Total</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {eligibleOrders.map((order) => (
                  <tr key={order._id}>
                    <td>{order._id}</td>
                    <td className={order.status === "Delivered" ? "greenColor" : "redColor"}>
                      {order.status}
                    </td>
                    <td>{order.cart.length}</td>
                    <td>{`US$ ${order.totalPrice}`}</td>
                    <td>
                      <Link to={`/user/order/${order._id}`}>
                        <button className="profile-content-component-view-btn" aria-label={`View refund order ${order._id}`}>
                          <AiOutlineArrowRight />
                        </button>
                      </Link>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="profile-settings-empty-state">
          <h3>No refund requests</h3>
          <p>Refund and return activity will appear here when a request is opened.</p>
          <Link to="/profile" className="profile-settings-empty-action">View Profile</Link>
        </div>
      )}
    </div>
  );
};

export default AllRefundOrders;
